// extracted by mini-css-extract-plugin
export var inner = "Banner-module--inner--f0ee8";
export var wrapper = "Banner-module--wrapper--b41cd";